import React, {useState} from 'react';
import axios from "axios";
import {toast} from "react-toastify";
import Auth from "@system/config/auth";
import Helper from 'src/support/Helper';
import logo from 'src/assets/images/logo.svg';
import email_icon from 'src/assets/images/email-icon.svg';

const ForgotPassword = () => {
    let [email, setEmail] = useState(false);
    let [sAuth, setSAuth] = useState({success: null});
    let [message, setMessage] = useState('');
    const serverCall = async () => {
        if (email) {
            await axios.get(Helper.appendTierQuery(Auth.FORGOT_PASSWORD + email)).then((res) => {
                setSAuth({success: res.data.isSuccessFull});
                if (res.data.isSuccessFull) {
                    setMessage(res.data.errorMessage);
                    toast.success(res.data.errorMessage, {
                        position: "bottom-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                } else {
                    toast.error(res.data.errorMessage, {
                        position: "bottom-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            })
        } else {
            setSAuth({success: false});
        }
    };
    return (
        <>
            <div className="login-page">
                <div className="login-wrapper">
                    <div className="login-logo">
                        <img className="img-fluid" src={logo}/>
                    </div>
                    <div className="login-box pb-0"
                         style={
                             sAuth.success === true ? {
                                 height: 'auto'
                             } : {}
                         }
                    >
                        {sAuth.success === true &&
                        <div>
                            <div className="signin-title text-green pb-5"
                                 style={
                                     {
                                         fontSize: '21px'
                                     }
                                 }
                            >{message}</div>
                        </div>
                        }

                        {(!sAuth.success || sAuth.success === false) &&
                        <>
                            <div className="signin-title text-green">Forgot Password</div>
                            <div>
                                <div className="form-group">
                                    <label htmlFor="email">Email Address:<span className="astric">*</span></label>
                                    <div className="input-box input-box-email">
                                        <input type="email" className="form-control" id="email"
                                               placeholder="Enter Email Address"
                                               onChange={e => setEmail(e.target.value)}
                                               name="email"/>
                                    </div>
                                </div>
                                <div className="text-center">
                                    <button
                                        disabled={!email}
                                        type="submit" className="bs5 btn btn-primary w-100 login-btn mb-4 "
                                        onClick={e => serverCall()}
                                    >SIGN IN
                                    </button>
                                </div>                                
                            </div>
                        </>
                        }
                    </div>
                    <div className="login-help">
                        <a href="">Continue to www.avnet.com </a>
                        <a href="">Help </a>
                    </div>
                </div>
                <div className="login-footer">
                    Copyright ©2022 Avnet, Inc. All rights reserved.
                </div>
            </div>
        </>
    )
}

export default ForgotPassword;